import React from "react";
import "./style.scss";
import { getStatusColor } from "../../../util/statusColor";

type OrderCardProps = {
  off_taker: string;
  start_date: string;
  due_date: string;
  product: string;
  status: string;
  quantity: number;
};
const OrderCard: React.FC<OrderCardProps> = ({
  off_taker,
  start_date,
  due_date,
  product,
  status,
  quantity,
}) => {
  return (
    <div
      className="order-card-container"
      style={{ fontFamily: "Poppins", fontWeight: 700 }}
    >
      <div className="order-card-title">Basic info</div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <div className="wrapper">
          <div className="label">Off taker</div>
          <div className="value">{off_taker}</div>
        </div>

        <div className="wrapper">
          <div className="label">Product</div>
          <div className="value">{product}</div>
        </div>

        <div className="wrapper">
          <div className="label">Quantity</div>
          <div className="value">{quantity} qt</div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="wrapper">
          <div className="label">Status</div>
          <div
            className="value"
            style={{
              borderRadius: 5,
              display: "flex",
              justifyContent: "center",
              width: 120,
              paddingTop: 6,
              paddingBottom: 6,
              color: `${getStatusColor(status)}`,
              backgroundColor: `${getStatusColor(status)}44`,
            }}
          >
            {status}
          </div>
        </div>

        <div className="wrapper">
          <div className="label">Start date</div>
          <div className="value">{start_date}</div>
        </div>

        <div className="wrapper">
          <div className="label">Due date</div>
          <div className="value">{due_date}</div>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
